// WARNING THIS FILE IS LOADED BEFORE JQUERY AND OTHER STUFF

export function onProductClick(productFieldObject) {
    dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
            'currencyCode': 'SEK',
            'click': {
                'actionField': { 'list': 'Produktsida' },      // Optional list property.
                'products': [productFieldObject]
            }
        },
        'eventCallback': function () {
        }
    });
}

export function onProductView(productFieldObject) {
    if (productFieldObject == null || productFieldObject.length === 0) {
        return;
    }

    dataLayer.push({
        event: "productDetail",
        'ecommerce': {
            'detail': {
                'actionField': {
                    'list': "Product Detail Page"
                },
                'products': productFieldObject
            }
        }
    });
}

export function addToCart(productFieldObject, orgno) {
    productFieldObject[0].brand = orgno;

    dataLayer.push({
        'event': "addToCart",
        'ecommerce': {
            'currencyCode': 'SEK',
            'add': {
                'products': productFieldObject
            }

        }
    });
}

export function onCheckout(productFieldObject, eventCallback) {
    dataLayer.push({
        event: "checkout",
        ecommerce: {
            checkout: {
                actionField: {
                    step: 1
                },
                'products': [productFieldObject]
            }
        }
    });
}

export function onPurchase(actionFieldObject, productFieldObject) {
    if (actionFieldObject != null && actionFieldObject.id != "") {
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                'purchase': {
                    'actionField': actionFieldObject,
                    'products': productFieldObject
                }
            }
        });
    }
}

export function validateAddToCart(clickedElementId, contentId) {
    if (clickedElementId === contentId.toString()) {
        return true;
    }
    return false;
}
